import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';


const routes: CustomRoute = {
	path: '/sponsored-by',
	components: () => [],
	render: (_, children) => children,
	onEnter: async () => {},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'sponsoredBy' */ './component')],
			render: ([SponsoredBy]) => <SponsoredBy />,
			onEnter: async ({ next }) => {
				console.log('on Enter sponsoredBy');
				await next();
				console.log('on Enter sponsoredBy / end');
			},
		},
	],
};

export default routes;
